import { render, staticRenderFns } from "./bankArchiveGetBalance.vue?vue&type=template&id=668c3d2c"
import script from "./bankArchiveGetBalance.vue?vue&type=script&lang=js"
export * from "./bankArchiveGetBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports